// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Qd0-","title":"styles_title__1pPKA"};